export default __webpack_public_path__ + "static/Montserrat-600italic-c4fcfeeb057724724097167e57bd7801.woff";